import { ImageUpload, OrderItemChangeImage } from "services/types";
import { KeyValue } from "types";

export abstract class converting {
    public static convertUploadImageObjectsToFormData = async (imageUpload: ImageUpload, enqueueFileForOnBase: boolean = true): Promise<FormData> => {
        const formData = new FormData();

        if (enqueueFileForOnBase) {
          formData.append(`docTypeName`, imageUpload.docTypeName);
          formData.append('keyValues', this.converKeyValueToString(imageUpload.keyValues))
        }

        imageUpload.files.forEach((file, fileIndex) => {
          formData.append(`$[files][${fileIndex}]`, file);
        });

        return formData
    }

    public static convertFileUrlToBlobObject = (dataURL: string): Blob => {
      const arr = dataURL.split(',');
      const mime = arr[0].match(/:(.*?);/)![1]
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n)
      while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    }

    public static convertChangeImageFilesToBlobObjects = (images: OrderItemChangeImage[]): OrderItemChangeImage[] => {
      let result: OrderItemChangeImage[] = []
      images.forEach(image => {
         result.push({
          ...image,
          file: converting.convertFileUrlToBlobObject(image.file.toString())
         })
      })

      return result
    }

    public static convertToImageUploadObject = async (items: OrderItemChangeImage[]): Promise<ImageUpload[]> => {
        const images = Object.values(
          items.reduce((result, item) => {
            const key = `${item.loadNumber}_${item.orderNumber}_${item.itemNumber}`;
            if (result[key]) {
              result[key].push(item);
            } else {
              result[key] = [item];
            }
            return result;
          }, {} as { [key: string]: OrderItemChangeImage[] }))
       
        const result: ImageUpload[] = images.map((items) => ({ keyValues: [{key: 'LoadNum', value: items[0].loadNumber}, {key: 'OrderNum', value: items[0].orderNumber}, {key: 'ItemNum', value: items[0].itemNumber.toString()}], files: items.map(x => x.file as Blob), docTypeName: 'Customer%20Refusal%20Pictures' })) 
       
        return result
    };

    private static converKeyValueToString = (values: KeyValue<string, string>[]): string => {
      let result = values.reduce((obj, {key, value}) => {
        obj[key as string] = value 
        return obj
      }, {} as {[key: string]: string})

      return JSON.stringify(result)
    }

}